const generateCorrespondentVariant = (options, option, value, variants, currentVariant) => {
	const otherOptions = options
		.filter((o) => o._key !== option._key)
		.map((o) => +o._key + 1);

	// Find the correspondent variant for the current value and option
	const correspondentVariant = variants.find((variant) =>
		variant.store[`option${+option._key + 1}`] === value &&
		otherOptions.every((o) => currentVariant.store[`option${o}`] === variant.store[`option${o}`])
	);

	return correspondentVariant;
};

export default generateCorrespondentVariant;